export default "__VITE_ASSET__5cBPqS30__"